import MultiplePlaylistsHeader from './MultiplePlaylistsHeader'

export default MultiplePlaylistsHeader
// eslint-disable-next-line import/export
export * from './MultiplePlaylistsHeader'
